import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import { S3_ASSETS_BUCKET_URL } from '@/helpers/constants/LandingPage';
let AvatarIndex = class AvatarIndex extends Vue {
    constructor() {
        super(...arguments);
        this.avatarUrl = '';
    }
    get imageDimension() {
        return {
            height: this.imageHeight + this.dimensionUnit,
            width: this.imageWidth + this.dimensionUnit,
        };
    }
    defaultImageUrl() {
        this.avatarUrl = require('@/assets/images/chatgenie_default_avatar.png');
    }
    mounted() {
        this.avatarUrl = this.imageUrl || `${S3_ASSETS_BUCKET_URL}/chatgenie_default_avatar.png`;
    }
};
__decorate([
    Prop({ default: '' })
], AvatarIndex.prototype, "color", void 0);
__decorate([
    Prop({ default: '' })
], AvatarIndex.prototype, "className", void 0);
__decorate([
    Prop({ default: '48px' })
], AvatarIndex.prototype, "wrapperSize", void 0);
__decorate([
    Prop({ default: '48' })
], AvatarIndex.prototype, "imageHeight", void 0);
__decorate([
    Prop({ default: '48' })
], AvatarIndex.prototype, "imageWidth", void 0);
__decorate([
    Prop()
], AvatarIndex.prototype, "imageUrl", void 0);
__decorate([
    Prop({ default: 'avatar' })
], AvatarIndex.prototype, "alt", void 0);
__decorate([
    Prop({ default: 'px' })
], AvatarIndex.prototype, "dimensionUnit", void 0);
AvatarIndex = __decorate([
    Component
], AvatarIndex);
export default AvatarIndex;
